import type { SignatureCodes } from '../api/coach-signature.js';
import { HAND_WORDS } from './hand-words.js';

/**
 * An athlete's codes as on the card banner: each code in a ring of its family
 * colour (tokens.css), the words in the text colour, then bats/throws -
 * "G2 Ce Ai · RHB/RHT" - full forms (RE-35). A motivation takes its colour from its first letter
 * (ruled 24 October): C and R red, A green, P yellow, U blue. The two
 * motivations sit together inside one outline (Matthew, 25 October).
 */

const MOTIVATION_FAMILY: Record<string, string> = { C: 'r', R: 'r', A: 'g', P: 'c', U: 'd' };

/** "c", "d", "g" or "r", for the ring's --family-* colour. */
export function codeFamily(code: string, kind: 'profile' | 'motivation'): string {
  const letter = code.charAt(0);
  return kind === 'profile' ? letter.toLowerCase() : (MOTIVATION_FAMILY[letter] ?? 'd');
}

export function CodeRing({ code, kind }: { code: string; kind: 'profile' | 'motivation' }) {
  return <span className={`code-ring family-${codeFamily(code, kind)}`}>{code}</span>;
}

export function SignatureCodeLine({ codes }: { codes: SignatureCodes }) {
  const hands = [HAND_WORDS.of('bats', codes.bats), HAND_WORDS.of('throws', codes.throws)].filter(Boolean).join('/') || null;
  return (
    <span className="code-line">
      {codes.motor_profile ? <CodeRing code={codes.motor_profile} kind="profile" /> : null}
      {codes.motivation_1 || codes.motivation_2 ? (
        <span className="code-group">
          {[codes.motivation_1, codes.motivation_2].map((code) => (code ? <CodeRing key={code} code={code} kind="motivation" /> : null))}
        </span>
      ) : null}
      {hands ? <span className="code-hands">· {hands}</span> : null}
    </span>
  );
}
